import { isEmptyNullOrUndefined } from "./validation.utils";

export function getQueryString(params: Record<string, any>): string {
  const urlParams = new URLSearchParams();

  for (const [key, val] of Object.entries(params)) {
    if (Array.isArray(val)) {
      for (const x of val) {
        if (!isEmptyNullOrUndefined(x)) {
          urlParams.append(key, x.toString());
        }
      }
    }
    else {
      if (val) {
        urlParams.append(key, val.toString());
      }
    }
  }

  return urlParams.toString();
}